import FeatureConfigDetailsApi from "../../services/api/FeatureConfigDetails";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";
import qs from "qs";

function handleError(err) {
  console.log("error in change logs actions:", err);
}

export const getConfigChangeLog =
  (payload = {}) =>
  async (dispatch) => {
    try {
      let finalPayload = {
        ...payload,
      };
      const queryParams = qs.stringify(finalPayload, { addQueryPrefix: true });
      dispatch(setLoader(true));
      let response = await FeatureConfigDetailsApi.getConfigChangeLog(
        queryParams
      );
      dispatch(setLoader(false));
      if (response) {
        return response;
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const updateConfig = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await FeatureConfigDetailsApi.updateConfig(payload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.UPDATION_SUCCESS,
        })
      );
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
